module.exports = __webpack_public_path__ + "img/Bear09.16383447.jpg";